export default __webpack_public_path__ + "static/media/after-400.9b74e5f2.png";